/*
 * Lib Module Modals
 * TODO: Alotta documentation
 */

Lib.Modal = (function() {
    var self = {};

    $(Lib).on('document.ready', function() {
        $(document).on('click', '[data-close-modal]', self.close);

        $(document).on('click', '[data-modal-from-template]', function(e) {

            if ($(e.target).is($('tr td.actions, tr td[data-norowlink]'))) {
                return;
            }

            var template = $(this).data('modal-from-template');
            if (typeof template === 'string') {
                self.createFromTemplate(template, {});
            } else {
                if ('name' in template) {
                    self.createFromTemplate(template.name, template.data || {}, template.options || {});
                } else {
                    Lib.Debug.warn('Trying to make a modal from template, but no template.name defined in [data-modal-from-template]');
                }
            }
        });

        $(document).on('keydown', function(e) {
            if (e.which === 27) { // Escape
                self.initializeDestroy();
            }
        });
    });

    /**
     *
     * @param content
     * @param options_
     */
    self.create = function(content, options_) {

        // Default options
        var options = $.extend(false, {
            onClose: Lib.Noop.true, // returns true
            onOpen: Lib.Noop.true, // returns undefined
            timeout: false,
            closable: true,
            closebutton: true,
            autofocus: false,
            modalname: false
        }, options_);

        self.onClose = options.onClose;

        // modal variable and get existing modal
        var modal;
        var existingModal = $('#modal-wrapper').find('.modal');

        // If we have an existing modal
        if (existingModal.length > 0) {

            // Use existing modal as modal
            modal = existingModal;
        } else {
            // Build the modal
            modal = self.buildModal(options);
        }

        if (self.wrapperVisible) {
            modal.hide(0, function() {
                modal.fadeIn(200);
            });
        }

        // Fadein the whole modal
        self.wrapperShow();

        // Check if we need to timeout close
        if (options.timeout) {
            self.closeTimeout = setTimeout(function() {
                self.initializeDestroy();
            }, options.timeout);
        }

        // Get and add the content
        var modalContent = modal.find('.modal-content').html(content);

        if (options.closebutton) {
            modalContent.append(Lib.Element.spawn('i', {'data-close-modal': '', 'class': 'modal-close is-icon material-icons m-fw'}, 'close'));
        }

        // Reattach ripples for buttons inside the modal
        Lib.Animation.ripple();

        // Attach toggles in the modal
        var toggles = modalContent.find('[data-toggle]');
        if (toggles.length !== 0) {
            Lib.Toggle.bindToggles(toggles);
        }

        // Attach datepickers in the modal
        var datepickers = modalContent.find('input[data-datepicker-options]');
        if (datepickers.length !== 0) {
            $('input[data-datepicker-options]:focus').blur();
            Lib.Datepicker.initializeDatepickers(datepickers);
        }

        // Attach fileuploads in the modal
        var uploads = modalContent.find('.dropzone');
        if (uploads.length !== 0) {
            Lib.Upload.initializeDropzones(uploads);
        }
        // Attach wysiwyg in the modal
        var wysiwyg = modalContent.find('textarea[data-wysiwyg]');
        if (wysiwyg.length !== 0) {
            Lib.Wysiwyg.bindEditor(wysiwyg);
        }

        // Attach autosizes in the modal
        var textareas = modalContent.find('textarea[data-autosize]:not([data-wysiwyg])');
        if (textareas.length !== 0) {
            Lib.Textarea.enableAutosize(textareas);
        }

        // Attach decimals in the modal
        var decimalFields = modalContent.find('input[type="text"][data-decimal]');
        if (decimalFields.length !== 0) {
            Lib.InputMask.bindDecimal(decimalFields);
        }

        // Attach counters in the modal
        var textareasCounter = modalContent.find('textarea[data-counter]:not([data-wysiwyg])');
        if (textareasCounter.length !== 0) {
            Lib.Textarea.enableCounter(textareasCounter);
        }

        // Focus the first element, if we want that
        if (options.autofocus) {
            if (typeof options.autofocus === 'string') {
                $(options.autofocus).focus();
            } else {
                if (options.autofocus instanceof $) {
                    options.autofocus.focus();
                } else {
                    modal.find(':input:not([type="submit"]):not(:hidden)').first().focus();
                }
            }
        } else {
            modal.find(':input[autofocus]:not(:hidden)').first().focus();
        }

        // Bind tooltips
        Lib.Tooltip.bindTooltips(($('.modal [data-tooltip]')));

        if (options.modalname) {
            $(Lib).trigger('modal.' + options.modalname + '.open', [options]);
        }

        // Callback
        options.onOpen();

        // Bind click to close
        modal.on('click', function(e) {
            if ($(e.target).hasClass('modal')) {
                // Launch callback
                if (options.closable) {
                    // Aka destroy
                    self.initializeDestroy();
                }
            }
        });
    };

    /**
     * Build the modal element and return it
     * @param options_
     * @returns {*|jQuery|HTMLElement}
     */
    self.buildModal = function(options_) {

        // Default options
        var options = $.extend(false, {
            modalClass: '',
            small: false,
            large: false,
            extralarge: false,
            animationIn: false,
            animationOut: false
        }, options_);

        // If we want a small modal
        if (options.small) {
            options.modalClass += ' modal-small';
        }

        // If we want a large modal
        if (options.large) {
            options.modalClass += ' modal-large';
        }

        // If we want a large modal
        if (options.extralarge) {
            options.modalClass += ' modal-extra-large';
        }

        // Initialize div
        var modal = Lib.Element.spawn('div', {'class': 'modal ' + options.modalClass});

        // Initialize content div
        var modalContent = Lib.Element.spawn('div', {'class': 'modal-content'});

        if (options.animationIn) {
            modalContent.addClass('animated double-speed ' + options.animationIn);
            modalContent.data('animationIn', options.animationIn);
            if (options.animationOut) {
                modalContent.data('animationOut', options.animationOut);
            }
        }

        // Add modalContent to modal
        modal.append(modalContent);

        // Add modal to body
        $('#modal-wrapper').append(modal);

        // Return modal
        return modal;
    };

    /**
     * Create a modal from a script template
     * @param templatename
     * @param templatedata
     * @param options
     * @returns {boolean}
     */
    self.createFromTemplate = function(templatename, templatedata, options) {

        Lib.Benchmark.start('Modal createFromTemplate');

        var contents = Lib.Template.parse(templatename, templatedata);
        options = options || Lib.Template.templateElement(templatename).data('template-options') || {};

        if (contents) {
            options = $.extend(true, options, {
                modalname: templatename
            });
            self.create(contents, options);
        }

        Lib.Benchmark.stop('Modal createFromTemplate', {max: 300});
    };

    /**
     *
     * @param options_
     * @returns {*|jQuery}
     */
    self.card = function(options_) {

        // Default card options
        var options = $.extend(false, {
            color: 'blue',
            title: false,
            subtitle: false,
            content: false,
            titleClass: false,
            subtitleClass: false,
            contentClass: false,
            small: false,
            template: false,
            buttons: false,
            header: true
        }, options_);

        // Initialize card div
        var card = Lib.Element.spawn('div', {'class': 'card card-' + options.color});

        var cardHeader = false;
        // If header isnt disabled
        if (options.header) {
            // Initialize card header
            cardHeader = Lib.Element.spawn('div', {'class': 'card-header'});

            // If we want a card title
            if (options.title) {

                // Initialize card title
                var cardTitle = Lib.Element.spawn('div', {'class': 'card-title'});

                // Insert card title
                cardTitle.html(options.title);

                // If specific card title class, add it
                if (options.titleClass) {
                    cardTitle.addClass(options.titleClass);
                }

                // Append the title to the cardHeader
                cardHeader.append(cardTitle);
            }

            // If we want a subtitle
            if (options.subtitle) {

                // Initialize the card subtitle
                var cardSubtitle = Lib.Element.spawn('div', {'class': 'card-subtitle'});

                // Insert card subtitle
                cardSubtitle.html(options.subtitle);

                // If specific card subtitle class, add it
                if (options.subtitleClass) {
                    cardSubtitle.addClass(options.subtitleClass);
                }

                // Append the subtitle to the cardHeader
                cardHeader.append(cardSubtitle);
            }

            // Add header to the card
            card.append(cardHeader);
        }
        // Initialize card content div
        var cardContent = Lib.Element.spawn('div', {'class': 'card-content'});

        // Default to no content
        var content = false;

        // If we provided a template
        if (options.template) {

            // And its an object
            if (typeof options.template === 'object') {

                // Get the parsed template
                content = Lib.Template.parse(options.template.name, options.template.data);
            } else {
                // Get the parsed template
                content = Lib.Template.parse(options.template, {});

            }
        } else {

            // No template? content = passed content
            content = options.content;
        }

        // If specific content class, add it
        if (options.contentClass) {
            cardContent.addClass(options.contentClass);
        }

        var cardFooter = false;

        // Do we need a footer?
        if (options.buttons) {

            // Initialize footer div
            cardFooter = Lib.Element.spawn('div', {'class': 'card-footer'});

            // Loop through all the buttons
            $.each(options.buttons, function(label, button) {

                // Default button options
                var buttonOptions = $.extend(false, {
                    color: 'blue',
                    close: false,
                    label: label,
                    onClick: false,
                    disabled: false
                }, button);

                // Build the button
                var buttonElement = Lib.Element.spawn('button', {'class': 'button button-' + buttonOptions.color}, buttonOptions.label);

                // If we should bind anything to the button

                if (buttonOptions.close || buttonOptions.onClick) {
                    buttonElement.on('click', function(e) {
                        e.preventDefault();

                        if (buttonOptions.onClick) {
                            buttonOptions.onClick();
                        }

                        if (buttonOptions.close) {
                            self.initializeDestroy();
                        }
                    });
                }

                if (buttonOptions.disabled) {
                    buttonElement.prop('disabled', 1);
                }

                cardFooter.append(buttonElement);
            });

        }
        // If we have content, add it to the cardContent and add the cardContent to the card
        if (content !== false) {
            if (content instanceof $ && content.find('.card-footer').length) {
                content.appendTo(card);
            } else {
                cardContent.append(content).appendTo(card);
            }
        } else if (options.header && cardHeader !== false) {

            // No content? Make the header prettier
            cardHeader.addClass('m-b-0 b-w-b-0');
        }

        // If we have a footer
        if (cardFooter !== false) {
            card.append(cardFooter);
        }

        if ('create' in options) {
            return self.create(card, options.create);
        }

        return card;
    };

    /**
     *
     * Function to build a modal with a card and some settings
     *
     * @param cardOptions_
     * @param modalOptions_
     */
    self.popup = function(cardOptions_, modalOptions_) {

        // Default card options
        var cardOptions = $.extend(false, {
            title: '&nbsp;',
            content: '&nbsp;',
            color: 'blue',
            buttons: {
                'Ok': {
                    close: true
                }
            }
        }, cardOptions_);

        // Default modal options
        var modalOptions = $.extend(false, {
            small: true
        }, modalOptions_);

        self.create(self.card(cardOptions), modalOptions);
    };

    /**
     *
     * Alert modal
     *
     * @param cardOptions_
     * @param modalOptions_
     */
    self.alert = function(cardOptions_, modalOptions_) {

        // Default card options
        var cardOptions = $.extend(false, {
            title: 'Oeps!',
            content: 'Er is iets fout gegaan!',
            color: 'deep-orange',
            buttons: {
                'Ok': {
                    close: true
                }
            }
        }, cardOptions_);

        // Default modal options
        var modalOptions = $.extend(false, {
            small: true
        }, modalOptions_);

        self.popup(cardOptions, modalOptions);
    };

    /**
     *
     * Success modal
     *
     * @param cardOptions_
     * @param modalOptions_
     */
    self.success = function(cardOptions_, modalOptions_) {

        // Default card options
        var cardOptions = $.extend(false, {
            title: 'Gelukt!',
            color: 'green',
            content: 'Je actie is succesvol uitgevoerd',
            buttons: {
                'Ok': {
                    close: true
                }
            }
        }, cardOptions_);

        // Default modal options
        var modalOptions = $.extend(false, {
            small: true
        }, modalOptions_);

        self.popup(cardOptions, modalOptions);
    };

    /**
     *
     * Warning modal
     *
     * @param cardOptions_
     * @param modalOptions_
     */
    self.warn = function(cardOptions_, modalOptions_) {

        // Default card options
        var cardOptions = $.extend(false, {
            title: 'var op!',
            color: 'amber',
            content: 'Er is iets aan de hand!',
            buttons: {
                'Ok': {
                    close: true
                }
            }
        }, cardOptions_);

        // Default modal options
        var modalOptions = $.extend(false, {
            small: true
        }, modalOptions_);

        self.popup(cardOptions, modalOptions);
    };

    /**
     *
     * Confirm modal
     *
     * @param cardOptions_
     * @param modalOptions_
     *
     */
    self.confirm = function(cardOptions_, modalOptions_) {

        // Default card options
        var cardOptions = $.extend(false, {
            title: '?',
            color: 'blue',
            titleClass: 'text-left',
            contentClass: 'text-left',
            content: 'Weet je het zeker?',
            buttons: {
                // Yes button
                'Ja': {
                    color: 'red',
                    onClick: Lib.Noop.true
                },
                // No button
                'Nee': {
                    color: 'blue',
                    onClick: Lib.Noop.true
                }
            }
        }, cardOptions_);

        // Default modal options
        var modalOptions = $.extend(false, {
            small: true,
            animationIn: 'fadeInDown',
            animationOut: 'fadeOutDown'
        }, modalOptions_);

        self.popup(cardOptions, modalOptions);
    };

    self.close = function(e) {
        if (e) {
            e.preventDefault();
        }
        self.initializeDestroy();
    };
    /**
     * Initialize destroying the modal, after doing some checks
     */
    self.initializeDestroy = function() {

        if (typeof self.onClose === 'function') {
            // Launch onClose callback
            self.onClose();
        }

        $(Lib).trigger('modal.close');

        // If there is a close timeout
        clearTimeout(self.closeTimeout);

        // Get the content
        var modalContent = $('.modal .modal-content');

        // See if it is animated
        if (modalContent.hasClass('animated')) {

            var animations = {in: modalContent.data('animationIn'), out: modalContent.data('animationOut')};

            if (animations.in) {
                modalContent.removeClass(animations.in);
            }

            if (animations.out) {
                modalContent.addClass(animations.out);
            }

            // After fadeout, trigger the click, for nice visual fx
            setTimeout(function() {
                self.destroy();
            }, 250);
        } else {

            // Just destroy it
            self.destroy();
        }

    };

    /**
     * Destroy the modal
     */
    self.destroy = function() {
        self.wrapperHide();
    };

    self.wrapperVisible = false;

    self.wrapperShow = function() {
        const body = $('body');

        body.addClass('modal-open');
        if (self.body_has_scrollbar()) {
            body.addClass('modal_body-has-scrollbar');
        }
        $('#modal-wrapper').fadeIn(200);
        self.wrapperVisible = true;
    };

    self.wrapperHide = function(fromLoader) {

        fromLoader = fromLoader || false;

        let modalWrapper = $('#modal-wrapper');
        if (fromLoader === false) {
            if (modalWrapper.find('>.loader').length === 0) {
                modalWrapper.fadeOut(200, function() {
                    modalWrapper.find('.modal').remove();
                    $('body').removeClass('modal-open modal_body-has-scrollbar');
                });
            } else {
                modalWrapper.find('.modal').fadeOut(200, function() {
                    $(this).remove();
                    self.wrapperHide();
                });
            }
        } else {
            if (modalWrapper.find('>.modal').length === 0) {
                modalWrapper.fadeOut(200, function() {
                    $(this).find('.loader').remove();
                    $('body').removeClass('modal-open modal_body-has-scrollbar');
                });
            } else {
                modalWrapper.find('.loader').fadeOut(200, function() {
                    $(this).remove();
                    self.wrapperHide();
                });
            }
        }

        self.wrapperVisible = false;
    };

    self.body_has_scrollbar = function() {
        if (window.innerHeight) {
            return document.body.offsetHeight > window.innerHeight;
        } else {
            return document.documentElement.scrollHeight >
                document.documentElement.offsetHeight ||
                document.body.scrollHeight > document.body.offsetHeight;
        }
    };

    return self;

})();
